<div class="flex w-full h-full p-6 gap-6 bg-surface-50 flex-col">
  <p-card>
    <p-tabs [(value)]="tabOption" lazy>
      <div class="bg-white rounded-t-lg w-fit max-w-full min-w-0">
        <p-tablist class="w-fit max-w-full min-w-0">
          <p-tab value="locations" data-testid="locations-tab-locations">Locations</p-tab>
          <p-tab value="countries" data-testid="locations-tab-countries">Overseas Countries</p-tab>
        </p-tablist>
      </div>
      <p-tabpanels class="rounded-b-lg rounded-tr-lg">
        <p-tabpanel value="locations">
          <div class="flex flex-col gap-4">
            <div class="flex gap-2 items-center">
              <input type="text"
                     pInputText
                     [(ngModel)]="filterInput"
                     class="w-1/3"
                     pSize="small"
                     placeholder="Filter by name or category..."
              />
              <div class="bg-white rounded">
                <p-button label="Clear" size="small" severity="secondary" outlined
                          icon="fa fa-x" (onClick)="clear()" />
              </div>
              <div class="flex-1"></div>
              <p-button label="Add Location" size="small" icon="fa fa-plus"
                        (onClick)="openAddLocationModal()" />
            </div>

            @if (filteredLocations().length > 0) {
              <div class="text-xs text-slate-500">
                Showing {{filteredLocations().length}} locations
              </div>
              <div scrollHeight class="rounded-lg border border-surface-300 overflow-y-auto">
                <p-table [value]="filteredLocations()">
                  <ng-template #header>
                    <tr>
                      <th>Name</th>
                      <th>Alt. Names</th>
                      <th>In Region</th>
                      <th>Active Location</th>
                      <th>Category</th>
                      <th></th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-rowData>
                    <tr>
                      <td>{{getDefaultName(rowData)}}</td>
                      <td>{{getAltNames(rowData)}}</td>
                      <td>
                        @if (rowData.inRegion) {
                          <p-tag severity="info" rounded value="Yes" />
                        } @else {
                          <p-tag severity="danger" rounded value="No" />
                        }
                      </td>
                      <td>
                        @if (rowData.enabled) {
                          <p-tag severity="info" rounded value="Active" />
                        } @else {
                          <p-tag severity="secondary" rounded value="Inactive" />
                        }
                      </td>
                      <td>{{toLocationCategoriesText(rowData.category)}}</td>
                      <td>
                        <p-button class="edit" size="small" (onClick)="openEditLocationModal(rowData)">
                          <span>Edit</span>
                          <i class="fa-light fa-pencil"></i>
                        </p-button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            } @else if (hasFilter()) {
              <div class="pl-2 text-slate-900 text-sm font-normal font-['Inter'] leading-6 italic">No locations match this filter.</div>
            }
          </div>
        </p-tabpanel>

        <p-tabpanel value="countries">
          <div class="flex flex-col gap-4">
            <div class="flex gap-2 items-center">
              <input type="text"
                     pInputText
                     [(ngModel)]="countryFilterInput"
                     class="w-1/3"
                     pSize="small"
                     placeholder="Filter by country name..."
              />
              <div class="bg-white rounded">
                <p-button label="Clear" size="small" severity="secondary" outlined
                          icon="fa fa-x" (onClick)="clearCountryFilter()" />
              </div>
              <div class="flex-1"></div>
              <p-button label="Add Country" size="small" icon="fa fa-plus"
                        (onClick)="openCountryModal()" />
            </div>

            @if (filteredCountries().length > 0) {
              <div class="text-xs text-slate-500">
                Showing {{filteredCountries().length}} countries
              </div>
              <div scrollHeight class="rounded-lg border border-surface-300 overflow-y-auto">
                <p-table [value]="filteredCountries()">
                  <ng-template #header>
                    <tr>
                      <th>Name</th>
                      <th>Cost Group</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-rowData>
                    <tr>
                      <td>{{rowData.name}}</td>
                      <td>{{rowData.costGroup}}</td>
                      <td>
                        @if (rowData.enabled) {
                          <p-tag severity="info" rounded value="Active" />
                        } @else {
                          <p-tag severity="secondary" rounded value="Inactive" />
                        }
                      </td>
                      <td class="text-right">
                        <p-button class="edit" size="small" (onClick)="openCountryModal(rowData)">
                          <span>Edit</span>
                          <i class="fa-light fa-pencil"></i>
                        </p-button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            } @else if (hasCountryFilter()) {
              <div class="pl-2 text-slate-900 text-sm font-normal font-['Inter'] leading-6 italic">No countries match this filter.</div>
            } @else {
              <div class="pl-2 text-slate-900 text-sm font-normal font-['Inter'] leading-6 italic">No countries have been added yet.</div>
            }
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </p-card>

  <div class="p-2.5 w-full"></div>
</div>
